import React, { useState } from "react";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { Stack, Box, TextField, useTheme } from "@mui/material";

const PersianBirthdayPicker = ({ setTimestamps }) => {
  const theme = useTheme();

  const [selectedDate, setSelectedDate] = useState(null);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setTimestamps(date ? date.toDate().getTime() : null);
  };

  return (
    <Stack
      direction={"row"}
      alignItems={"center"}
      sx={{ direction: "rtl", width: "100%" }}
    >
      {/* birthday */}
      <Box sx={{ width: "100%", height: "100%", position: "relative" }}>
        <DatePicker
          value={selectedDate}
          onChange={handleDateChange}
          calendar={persian}
          locale={persian_fa}
          format="YYYY/MM/DD"
          containerStyle={{ width: "100%" }}
          render={(value, openCalendar) => (
            <TextField
              size="small"
              fullWidth
              value={value}
              onClick={openCalendar}
              sx={{
                input: {
                  // bgcolor: theme.palette.secondary.main,

                  overflow: "hidden",
                  // border: `2px solid ${theme.palette.primary.main}`,

                  fontSize: "1rem",
                  borderRadius: "6px",
                  py:".55rem" ,
                  color: theme.palette.background.lightBlue,
                  "&::-webkit-outer-spin-button": {
                    display: "none",
                  },
                  "&::-webkit-inner-spin-button": {
                    display: "none",
                  },
                  MozAppearance: "textfield",
                },
                fieldset: {
                  borderRadius: " 6px",
                  overflow: "hidden",
                  border: `2px solid ${theme.palette.primary.main}`,
                },
              }}
            />
          )}
        />
      </Box>
    </Stack>
  );
};

export default PersianBirthdayPicker;
